// extracted by mini-css-extract-plugin
export default {"container":"LibraryDetail_container__vBp7+"};